import { flatten } from 'flat';

import { OrderMethodEnum } from '../constants';
import { FiltersInterface } from '../types';

export interface PaginationType {
  limit: number;
  page: number;
}

export interface SortType {
  order: OrderMethodEnum;
  sortBy: string;
}

export interface ParsedFiltersInterface {
  pagination: PaginationType;
  sort?: SortType;
  filters?: Record<string, string>;
}

export const parseFilters = (filters: FiltersInterface): ParsedFiltersInterface => {
  const output = {} as ParsedFiltersInterface;

  if (filters.order && filters.sortBy) {
    output.sort = {
      order: filters.order,
      sortBy: filters.sortBy,
    };
  }

  if (filters.limit && filters.page) {
    output.pagination = {
      limit: filters.limit,
      page: filters.page - 1,
    };
  }

  if (filters.filters) {
    output.filters = filters.filters;
  }

  return flatten(output);
};
